import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getKeystoreItem, getProfile } from './selectors';
import { setKeystoreItem } from './actions';

export const useProfile = (immutable = false) => {
  const profile = useSelector(getProfile);

  const useKeyStore = (key, defaultValue = undefined) => {
    // `fullKey` must be a string in the KEYSTORE_WHITELIST
    const fullKey = `${key}`;
    const dispatch = useDispatch();
    const value =
      useSelector((state) => getKeystoreItem(state, fullKey)) ?? defaultValue;

    const setValue = useCallback(
      (newValue) => {
        try {
          dispatch(setKeystoreItem.signal(fullKey, newValue));
        } catch (error) {
          // request failed, do something?
          console.error(error);
        }
      },
      [dispatch, fullKey]
    );

    // user is anonymous, do nothing with keystore
    if (!profile.size) {
      return [undefined, () => {}];
    }
    return [value, setValue];
  };

  return {
    profile: immutable ? profile : profile.toJS(),
    useKeyStore,
  };
};
